import { PasswordValidationRequestImpl } from '../../../../core/api/passwordvalidation/passwordvalidationrequest';
import { PasswordValidationResponse } from '../../../../core/api/passwordvalidation/passwordvalidationresponse';
import { SecurityTokenRequestImpl } from '../../../../core/api/securitytoken/securitytokenrequest';
import { SecurityTokenResponse } from '../../../../core/api/securitytoken/securitytokenresponse';
import { SubscriberValidationRequestImpl } from '../../../../core/api/subscribervalidation/subscribervalidationrequest';
import { SubscriberValidationResponse } from '../../../../core/api/subscribervalidation/subscribervalidationresponse';
import { LoginProcessorFactory } from '../../../../core/processorfactory/loginprocessorfactory';
import { BaseContext } from '../../../../utils/basecontext';
import { APIModel, APIModelHandler, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { LoginDto } from '../../../../core/dto/login/logindto';
import { SubscriberValidationDtoImpl } from '../../../../core/dto/subscribervalidation/subscribervalidationdto';
import { SecurityTokenDtoImpl } from '../../../../core/dto/securitytoken/securitytokendto';
import { PasswordValidationDtoImpl } from '../../../../core/dto/passwordvalidation/passwordvalidationdto';
import { RsaService } from '../../../../utils/rsaservice';
import { LoginResponse } from 'src/com/sixdee/crbtportal/core/api/login/loginresponse';
import { PasswordValidationCCRequestImpl } from 'src/com/sixdee/crbtportal/core/api/passwordvalidationcc/passwordvalidationccrequest';
import { PasswordValidationCCDto, PasswordValidationCCDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/passwordvalidationcc/passwordvalidationccdto';
import { LogoutDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/logout/logoutdto';
import { LogoutResponse } from 'src/com/sixdee/crbtportal/core/api/myaccount/logout/logoutresponse';
import { LogoutRequestImpl } from 'src/com/sixdee/crbtportal/core/api/myaccount/logout/logoutrequest';

export interface LoginAPIModel extends APIModel {
    doLogin(loginRequestDto: LoginDto): void;
    logout(): void;
    getSecurityTokenCCRedirection(passwordValidationCCDto:PasswordValidationCCDto):void;
}

export class LoginAPIModelImpl extends APIModelImpl implements LoginAPIModel {
    private loginProcessorFactory: LoginProcessorFactory;

    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    loginCCRedirection(passwordValidationDto: PasswordValidationCCDto,securityToken:string): void 
    {
        console.log("Password & security token----",passwordValidationDto.getPassword(),"token",securityToken);
        let encryptedPassword = RsaService.getInstance(this.getContext().getProperty())
        .encryptWithNodeRSA(passwordValidationDto.getPassword() + securityToken);
        (passwordValidationDto as PasswordValidationCCDtoImpl).setPassword(encryptedPassword);
         (passwordValidationDto as PasswordValidationCCDtoImpl).setSecurityCounter(securityToken);
  
     this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().validateCCPassword()
      .success((settingsResponse: LoginResponse) => {
        this.getAPIModelHandler().onSuccess(settingsResponse.getAPIFeature(), 
        settingsResponse.getDescription(), settingsResponse); 
      })
      .failure((settingsResponse: LoginResponse) => {
        this.getAPIModelHandler().onFailure(settingsResponse.getAPIFeature(), 
        settingsResponse.getDescription(), settingsResponse);
      })
      .execute(new PasswordValidationCCRequestImpl(passwordValidationDto));
   }
   logout(): void 
   { 
           let logoutDto = new LogoutDtoImpl();
           logoutDto.setRefreshToken(this.getContext().getUserContext().getRefreshToken());
  
           this.getAPIProcesssorFactory().getMyAccountProcessorFactory()
           .getLogoutDetails()
           .success((logoutResponse: LogoutResponse)=>
           {
               this.getAPIModelHandler().onSuccess(logoutResponse.getAPIFeature(), 
               logoutResponse.getDescription(), logoutResponse.getAPIFeature());
             
            })
           .failure((logoutResponse: LogoutResponse)=>
            {
              this.getAPIModelHandler().onFailure(logoutResponse.getAPIFeature(), 
              logoutResponse.getDescription(), undefined);
            })
           .execute(new LogoutRequestImpl(logoutDto));
   } 
   getSecurityTokenCCRedirection(passwordValidationCCDto:PasswordValidationCCDto)
   {
       let securityTokenDto: SecurityTokenDtoImpl = new SecurityTokenDtoImpl();    
       this.loginProcessorFactory.getSecurityToken()
       .success((securityTokenResponse: SecurityTokenResponse) => {
            
           this.loginCCRedirection(passwordValidationCCDto, securityTokenResponse.getSecurityCounter());
       })
       .failure((securityTokenResponse: SecurityTokenResponse) => 
           {
               this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(),
                   securityTokenResponse.getDescription(), securityTokenResponse);
           })
           .execute(new SecurityTokenRequestImpl(securityTokenDto));
   }
    doLogin(loginDto: LoginDto): void {
        let subscriberValidationDto = new SubscriberValidationDtoImpl();
        subscriberValidationDto.setMsisdn(loginDto.getMsisdn());
        subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.loginProcessorFactory.validateSubscriber()
            .success(() => {
                this.getSecurityToken(loginDto);
            })
            .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                    subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
    }

    private getSecurityToken(loginDto: LoginDto) {
        let securityTokenDto: SecurityTokenDtoImpl = new SecurityTokenDtoImpl();
        this.loginProcessorFactory.getSecurityToken()
            .success((securityTokenResponse: SecurityTokenResponse) => {
                this.validatePassword(loginDto, securityTokenResponse.getSecurityCounter());
            })
            .failure((securityTokenResponse: SecurityTokenResponse) => 
            {
                this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(),
                    securityTokenResponse.getDescription(), securityTokenResponse);
            })
            .execute(new SecurityTokenRequestImpl(securityTokenDto));
    }
    
   
    private validatePassword(loginDto: LoginDto, securityToken: string) {
        let passwordValidationDto = new PasswordValidationDtoImpl();

        let encryptedPassword = RsaService.getInstance(this.getContext().getProperty())
        .encryptWithNodeRSA(loginDto.getPassword() + securityToken);

        passwordValidationDto.setMsisdn(loginDto.getMsisdn());
        passwordValidationDto.setEncryptedPassword(encryptedPassword);
        passwordValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());
        passwordValidationDto.setSecurityCounter(securityToken);

        this.loginProcessorFactory.validatePassword()
            .success((passwordValidationResponse: PasswordValidationResponse) => 
            {
                this.getAPIModelHandler().onSuccess(passwordValidationResponse.getAPIFeature(),
                loginDto.getMsisdn(), passwordValidationResponse);
            })
            .failure((passwordValidationResponse: PasswordValidationResponse) => {
                this.getAPIModelHandler().onFailure(passwordValidationResponse.getAPIFeature(),
                    passwordValidationResponse.getDescription(), passwordValidationResponse);
            })
            .execute(new PasswordValidationRequestImpl(passwordValidationDto));
    }
}





// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/login/loginapimodel.tsx